import Vue from 'vue';
import Router from 'vue-router';
import VueRouter from 'vue-router';

import ViewHolder from './components/ViewHolder.vue';

const MessagesIndex = () =>
	import(/* webpackChunkName: "messages" */ './views/messages/Index.vue');

Vue.use(Router);

const routes = [
	{
		path: '/messages/:id',
		redirect: to => ({
			//"/messages?thread_id=:id"
			name: 'messages',
			query: { thread_id: to.params.id },
		}), 
	},
	{
		path: '/messages',
		name: 'messages',
		component: MessagesIndex,
		meta: {
			disableNav: true,
			disableChat: true,
			preventScroll: true,
		}, 
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.matched.some((routeDef) => routeDef.meta.preventScroll))
			return false;
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

export default router;
